/* Mega-nav lazy images — Option C (16 Aug 2026).
   header.liquid ships the full text link tree server-side (SEO + no-JS safe);
   this script fetches the image tiles ONCE per session via the Section
   Rendering API and fills every [data-mega-img] placeholder.

   Failure philosophy: any error anywhere leaves the text nav fully working,
   just without pictures. Nothing here may ever break navigation. */
(function () {
  'use strict';
  var KEY = 'ww:meganav-imgs:v1';
  var attempts = 0;
  var inFlight = false;

  function fill(map) {
    var els = document.querySelectorAll('[data-mega-img]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.firstChild) continue; /* already hydrated */
      var entry = map[el.getAttribute('data-mega-img')];
      if (!entry) continue; /* empty collection / no image — box stays empty, matching old blank-image render */
      var img = document.createElement('img');
      if (el.getAttribute('data-mega-kind') === 'c' && entry.c2) {
        img.src = entry.c2;
        img.width = 80;
        img.height = 80;
      } else if (entry.t) {
        img.src = entry.t;
        img.width = 120;
        img.height = 120;
      } else {
        continue;
      }
      img.className = 'img-fit';
      img.loading = 'lazy';
      img.alt = el.getAttribute('data-mega-alt') || '';
      el.appendChild(img);
    }
  }

  function load() {
    if (inFlight || attempts >= 2) return; /* cap retries — never hammer */
    try {
      var cached = sessionStorage.getItem(KEY);
      if (cached) {
        fill(JSON.parse(cached));
        attempts = 2; /* done */
        return;
      }
    } catch (e) { /* storage unavailable (private mode) — fetch instead */ }
    inFlight = true;
    attempts++;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=mega-nav-images', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) { throw new Error('http ' + r.status); }
        return r.json(); /* also throws on bot-challenge HTML — caught below */
      })
      .then(function (json) {
        var html = json['mega-nav-images'];
        if (!html) { throw new Error('section missing'); }
        var m = html.match(/<script[^>]*data-mega-map[^>]*>([\s\S]*?)<\/script>/);
        if (!m) { throw new Error('map missing'); }
        var map = JSON.parse(m[1]); /* validate BEFORE caching or injecting */
        try { sessionStorage.setItem(KEY, m[1]); } catch (e) { /* fine */ }
        inFlight = false;
        fill(map);
      })
      .catch(function () {
        inFlight = false; /* leave text nav as-is; one retry allowed on next intent */
      });
  }

  /* Fetch on first nav intent... */
  var header = document.querySelector('#shopify-section-header, .section-header, header');
  if (header) {
    ['touchstart', 'mouseenter', 'focusin'].forEach(function (ev) {
      header.addEventListener(ev, load, { once: true, passive: true });
    });
  }
  /* ...and warm it off the critical path even if nobody touches the nav. */
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(load, { timeout: 5000 });
  } else {
    window.setTimeout(load, 4000);
  }
})();
